import { createRoute, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";

/**
 * Aula landing: redirects to "Learn" (`/learn`). Template list dashboard
 * was retired with the shrinkage of the todo domain.
 */
export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  beforeLoad: () => {
    // oxlint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: "/learn", replace: true });
  },
  component: () => null,
});
